/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const pencil = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M20.1 5.1L16.9 2 6.2 12.7l-1.3 4.4 4.5-1.3L20.1 5.1zM4 20.8h8v-1.5H4v1.5z" />
	</SVG>
);

export default pencil;
